import React from 'react';
import { CheckCircle2, Clock, FileText, Flame, Hourglass, MessageSquareText } from 'lucide-react';

const TONES = {
  slate: { label: 'text-slate-500', value: 'text-slate-900', icon: 'bg-teal-50 text-[#008080] border-teal-100' },
  amber: { label: 'text-amber-600', value: 'text-amber-600', icon: 'bg-amber-50 text-amber-600 border-amber-100' },
  green: { label: 'text-emerald-600', value: 'text-emerald-600', icon: 'bg-emerald-50 text-emerald-600 border-emerald-100' },
  violet: { label: 'text-violet-600', value: 'text-violet-700', icon: 'bg-violet-50 text-violet-600 border-violet-100' },
  rose: { label: 'text-rose-600', value: 'text-rose-600', icon: 'bg-rose-50 text-rose-600 border-rose-100' },
};

// stats: utils/ipoDashboard.js computeDashboardStats
const buildStats = (board, stats) => [
  { key: 'total', label: `${board.shortLabel} IPOs`, value: stats.total, note: 'In the live issue tracker', tone: 'slate', Icon: FileText },
  { key: 'pipeline', label: 'Pipeline', value: stats.pipeline, note: 'Upcoming & ongoing', tone: 'amber', Icon: Clock },
  { key: 'open', label: 'Open Now', value: stats.open, note: 'Accepting bids today', tone: 'green', Icon: CheckCircle2 },
  { key: 'yetToList', label: 'Yet to List', value: stats.yetToList, note: 'Bidding closed, listing due', tone: 'violet', Icon: Hourglass },
  {
    key: 'top',
    label: 'Top Subscription',
    value: stats.topSubscription ? `${stats.topSubscription.total.toFixed(2)}x` : '—',
    note: stats.topSubscription ? stats.topSubscription.company : 'No bidding data yet',
    tone: 'rose',
    Icon: Flame,
  },
  {
    key: 'reviews',
    label: 'Broker Reviews',
    value: stats.reviews,
    note: stats.reviewedIpos ? `Across ${stats.reviewedIpos} current IPO${stats.reviewedIpos === 1 ? '' : 's'}` : 'None for current IPOs yet',
    tone: 'slate',
    Icon: MessageSquareText,
  },
];

export const DashboardStatCards = ({ board, stats, loading }) => (
  <ul className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3 sm:gap-4">
    {buildStats(board, stats).map(({ key, label, value, note, tone, Icon }) => {
      const palette = TONES[tone];
      return (
        <li key={key} className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 min-w-0">
          <div className="flex items-start justify-between gap-2">
            <span className={`text-[11px] font-bold uppercase tracking-wider ${palette.label}`}>{label}</span>
            <span className={`w-7 h-7 rounded-lg border flex items-center justify-center flex-shrink-0 ${palette.icon}`}>
              <Icon className="w-3.5 h-3.5" />
            </span>
          </div>
          {loading ? (
            <div className="mt-2 h-8 w-14 rounded-md bg-slate-100 animate-pulse" aria-hidden="true" />
          ) : (
            <p className={`mt-2 text-2xl sm:text-3xl font-extrabold tracking-tight tabular-nums ${palette.value}`}>{value}</p>
          )}
          <p className="mt-1 text-xs text-slate-500 truncate" title={note}>
            {loading ? 'Loading…' : note}
          </p>
        </li>
      );
    })}
  </ul>
);

export default DashboardStatCards;
